module.exports = __webpack_public_path__ + "img/swiper6.c43ea8a8.png";